// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"my-deal-alerts_uk-open__AGKPs","grecaptcha-badge":"my-deal-alerts_grecaptcha-badge__ZV7ob","root":"my-deal-alerts_root__watiB","content":"my-deal-alerts_content__0InJg","list":"my-deal-alerts_list__uzypF","isDropdownOpen":"my-deal-alerts_isDropdownOpen__zXyVB","login":"my-deal-alerts_login__8vRCP","sidebarWrapper":"my-deal-alerts_sidebarWrapper__jBqcl","sidebar":"my-deal-alerts_sidebar__ObiDy","info":"my-deal-alerts_info__8vJgz"};
    if(module.hot) {
      // 1756311282976
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  